import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import api from '../utils/api';

const LABEL = 'block text-[10px] font-bold uppercase tracking-[0.05em] text-surface-muted mb-1';
const INPUT = 'w-full px-[10px] py-2 bg-surface-base text-surface-text border border-surface-border text-xs focus:outline-none focus:ring-2 focus:ring-accent rounded-[2px]';

export default function Register() {
  const [code, setCode] = useState('');
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    try {
      await api.post('/api/auth/register', { code, username, password });
      // Server does not return a token on register — redirect to login with a flash via ?registered=1.
      navigate('/login?registered=1');
    } catch (err) {
      setError(err.response?.data?.message || 'Registration failed.');
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-surface px-4">
      <div className="w-full max-w-[320px]">
        <div className="flex items-center gap-[10px] justify-center mb-6">
          <div
            className="w-7 h-7 bg-accent"
            style={{ clipPath: 'polygon(0 20%, 20% 0, 100% 0, 100% 80%, 80% 100%, 0 100%)' }}
          />
          <span className="font-bold text-[15px] uppercase tracking-[0.14em]">BAN MONITOR</span>
        </div>
        <div className="bg-surface-panel border border-surface-border p-[22px]">
          <div className="text-[11px] font-bold uppercase tracking-[0.1em] text-surface-muted mb-[14px]">Register</div>
          {error && <div className="text-steam-danger text-xs mb-3">{error}</div>}
          <form onSubmit={handleSubmit}>
            <label className={LABEL}>Registration code</label>
            <input className={`${INPUT} font-mono mb-3`} value={code} onChange={(e) => setCode(e.target.value)} required />
            <label className={LABEL}>Username</label>
            <input className={INPUT + ' mb-3'} value={username} onChange={(e) => setUsername(e.target.value)} required />
            <label className={LABEL}>Password</label>
            <input type="password" className={INPUT + ' mb-4'} value={password} onChange={(e) => setPassword(e.target.value)} required />
            <button type="submit" className="w-full py-[9px] bg-accent text-surface-base border-0 text-[11px] font-bold uppercase tracking-[0.08em] rounded-[2px]">Create account</button>
          </form>
        </div>
        <div className="text-center text-[11px] text-surface-muted mt-3">
          Already have one? <Link to="/login" className="text-accent hover:underline">Sign in</Link>
        </div>
      </div>
    </div>
  );
}
